.container {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  max-width: 40rem;
}

.description {
  color: var(--color-grayscale-light-slate);
  line-height: 1.8rem;
}
